import { useQuery } from '@apollo/client';
import logoBzcPath from 'Assets/images/BzcLogo1.svg';
import BannerApp from 'Components/BannerApp';
import { storageFactory } from 'Libs/storageFactory';
import AuthStore from 'Store/AuthStore';
import UiStore from 'Store/UiStore';
import { theme } from 'Ui';
import { IconIcoSearch } from 'Ui/Icons';
import IconeMenu from 'Ui/Icons/icons/IconeMenu';
import { DeviceEnum, OsEnum } from '__generated__/graphql-global-types';
import { isAndroid, isIOS, isMobile } from 'react-device-detect';
import styled from 'styled-components/macro';
import HeaderBasket from '../HeaderBasket';
import { getHeaderNavigation } from '../__generated__/getHeaderNavigation';
import headerNavigationQuery from '../headerNavigationQuery';
import SearchInput from './SearchInput';
import WishListMenu from '../DesktopHeader/WishListMenu';
import { useEffect } from 'react';
import { AccountHeader, CheckMark, LogoMobile } from 'Ui/Icons/icons';
import { useLocation } from 'react-router-dom';

const MobileHeaderHeight = 6.8;

// const StyledHeader = styled.div`
//   padding-top: ${MobileHeaderHeight}rem;
// `;

const HeaderMobileContainer = styled.div`
  width: 100%;
  padding: 0 1.6rem 0.8rem;
`;

const HeaderNavContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
`;

const HeaderLogoContainer = styled.div`
  /* width: 65%; */
  display: flex;
  /* margin-left: 1.8rem; */
`;

const HeaderMenuContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;

const TopBar = styled.div<{ $isTunnelRecap?: boolean }>`
  display: flex;
  align-items: center;
  height: ${MobileHeaderHeight}rem;
  justify-content: space-between;
  /* padding: 0 1.5rem; */
  /* border-bottom: 1px solid #eee; */
  background-color: ${(props) =>
    props.$isTunnelRecap ? 'var(--design-background-color)' : '#fff'};
  font-size: 2.5rem;
`;

const FixBar = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  padding-top: 1.6rem;
  background-color: #fff;
  z-index: 1000;
  box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.1);
  .addShadow {
    box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.1);
  }
`;

const Search = styled.div`
  @media screen and (max-width: ${theme.breakpoints.small}px) {
    margin-right: 1rem;
    svg {
      height: 2.6rem;
      width: 3.6rem;
    }
    svg path {
      stroke: ${theme.light.colors.purple};
      stroke-width: 3.8px;
    }
  }
  @media screen and (max-width: ${theme.breakpoints.micro}px) {
    margin: 0rem 0.5rem;
  }
`;
const Basket = styled.div`
  @media screen and (max-width: ${theme.breakpoints.small}px) {
    /* margin-right: 1rem; */
    svg {
      /* height: 2.6rem; */
    }
    svg path {
      // stroke: ${theme.light.colors.purple};
      stroke-width: 1px;
    }
  }
`;

const SuccessIcon = styled.div`
  background-color: rgb(223, 255, 109);
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin: 1rem auto; */
  margin-right: 1rem;
  position: absolute;
  bottom: 0;
  left: 14px;
  transform: translate3d(0, 35%, 0);
  svg path {
    stroke: #000 !important;
  }
  svg {
    font-size: 0.8rem;
  }
`;

const LogoTitle = styled.div`
  font-family: 'Montserrat' !important;
  font-size: 2.4rem;
  font-weight: 500;
  color: #000;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
`;
export default () => {
  const location = useLocation();
  const isLoggedIn = AuthStore.useStoreState((state) => state.isLoggedIn);
  const setSideMenuOpen = UiStore.useStoreActions(
    (actions) => actions.setSideMenuOpen
  );

  const cookieMobileAppPopup = UiStore.useStoreState(
    (state) => state.cookieMobileApp
  );

  const isTunnelRecap = location.pathname === '/v3/tunnel/recap/';

  const loggedIn = AuthStore.useStoreState((state) => state.isLoggedIn);
  const localStore = storageFactory(() => localStorage);

  const menuDevice: DeviceEnum = isMobile
    ? DeviceEnum.MOBILE
    : DeviceEnum.DESKTOP;
  const { data } = useQuery<getHeaderNavigation>(headerNavigationQuery, {
    variables: { device: menuDevice, os: OsEnum.SITE },
  });
  const links = (data && data.headerNavigation && data.headerNavigation) || [];
  const setPathHeaderMenu = UiStore.useStoreActions(
    (action) => action.setPathHeaderMenu
  );
  setPathHeaderMenu(links);

  const scrollShadow = document.getElementById('addShadowJs');
  const headerMobilePadding: any = document.getElementById('headermobile');

  // const setColor = (color: any, link: string) => {
  //   return color
  //     ? color
  //     : link === window.location.pathname
  //     ? `${theme.light.colors.purple}`
  //     : '#000';
  // };

  // const isLoggedIn =
  //   loggedIn || !!localStore.getItem('isLoggedIn') ? true : false;

  // if (!loggedIn) return <AnonymousHeader />;

  // if (!!localStore.getItem('isLoggedIn') === false) {
  //   return <AnonymousHeader />;
  // } else if (!!localStore.getItem('isLoggedIn') === false && !loggedIn) {
  //   return <AnonymousHeader />;
  // }

  return (
    <>
      {/* {loggedIn && ( */}
      <>
        <FixBar id="addShadowJs">
          {cookieMobileAppPopup && (isAndroid || isIOS) && (
            <BannerApp android={isAndroid} />
          )}

          <TopBar $isTunnelRecap={isTunnelRecap}>
            <HeaderMobileContainer id="headermobile">
              <HeaderNavContainer>
                <HeaderLogoContainer>
                  <a href="/">
                    <LogoTitle>Bazarchic</LogoTitle>
                  </a>
                </HeaderLogoContainer>
                <HeaderMenuContainer>
                  <div
                    style={{ position: 'relative' }}
                    onClick={() => {
                      setSideMenuOpen(true);
                    }}
                  >
                    {isLoggedIn && (
                      <SuccessIcon>
                        <CheckMark />
                      </SuccessIcon>
                    )}
                    <AccountHeader width="20" height="20" />
                  </div>
                  <div>
                    <WishListMenu />
                  </div>
                  <Basket>
                    <HeaderBasket />
                  </Basket>
                </HeaderMenuContainer>
              </HeaderNavContainer>
            </HeaderMobileContainer>
          </TopBar>
        </FixBar>
      </>
      {/* )} */}
    </>
  );
};
